<template>
  <li class="nav-item">
    <a class="nav-link" :class="{ active: isActive }" href="javascript:void(0)" @click="handleClick">
      <slot />
    </a>
  </li>
</template>

<script>
export default {
  name: 'TabComponent',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: this.active,
    };
  },
  inject: ['registerTab', 'activateTab'],
  mounted() {
    // Registra no TabsComponent e envia referência própria
    this.registerTab(this);
  },
  methods: {
    handleClick() {
      this.$emit('click');
      this.activateTab(this);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-link {
  &.active {
    background-color: transparent;
    border-color: var(--clr-yup-purple);
    color: #111519;
  }
}
</style>
